<!--
 * @Author: xiaohe
 * @LastEditors: xiaohe
-->
<template>
  <div class="tab_list">
    <div @click="goTo" class="img_logo">
      <img src="../../assets/info/logo1.png" class="logo1" alt="" />
      <div>金骊保电子保函平台</div>
    </div>
    <div v-if="isMenuShow" class="right_tab">
      <template>
        <a-tabs v-model="activeIndex" @tabClick="onClick">
          <a-tab-pane :key="1" tab="首页"> </a-tab-pane>
          <a-tab-pane :key="2" tab="保函申请"> </a-tab-pane>
          <a-tab-pane :key="3" tab="保函验真"> </a-tab-pane>
        </a-tabs>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isMenuShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      RouterArray: [
        {
          path: "/",
          name: "首页",
          id: 1,
        },
        {
          path: "/login",
          name: "保函申请",
          id: 2,
        },
        {
          path: "/guaranteeTruth",
          name: "保函验真",
          id: 3,
        },
      ],
      activeIndex: null,
    };
  },
  watch: {
    $route() {
      if (this.$route.path == "/products" || this.$route.path == "/login") {
        this.activeIndex = 2;
      }
    },
    immediate: true,
  },
  mounted() {
  
    if (this.$route.path == "/guaranteeTruth") {
      this.activeIndex = 3;
    }
    if (
      this.$route.path == "/orderCenter" ||
      this.$route.path == "/products" ||
      this.$route.path == "/user" ||
      this.$route.path == "/login" ||
      this.$route.path == "/register" ||
      this.$route.path == "/forgotPassword" ||
      this.$route.path == "/enterprise"
    ) {
      this.activeIndex = 2;
    }
  },
  methods: {
    onClick(e) {
      let url = this.RouterArray.filter((item) => {
        return item.id == e;
      })[0].path;
      this.$router.push({ path: url });
    },
    goTo() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="less" scoped>
.tab_list {
  width: 1200px;
    margin: auto;
    padding: 5px 0;
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    height: 62px;
  .right_tab {
    display: flex;
  }
  .img_logo {
    margin-right: 226px;
        display: flex;
        margin-top: 8px;
        line-height: 36px;
        img {
          width: 36px;
          height: 36px;
          margin-right: 8px;
        }
  }
  .tab_phone {
    padding-top: 8px;
    font-size: 22px;
    font-family: DIN Medium-Regular, DIN Medium;
    font-weight: 400;
    color: #0E52D4;
    margin-left: 30px;
  }
}
::v-deep .ant-tabs-bar {
  border-bottom: none !important;
}
::v-deep .ant-tabs-tab {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
::v-deep .ant-tabs-nav .ant-tabs-tab-active {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: bold;
  color: #0E52D4;
}
::v-deep .ant-tabs-ink-bar {
  background: #0E52D4;
}
::v-deep .ant-tabs-nav .ant-tabs-tab:hover {
  color: #0E52D4;
  font-weight: bold;
}
</style>
